var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    [
      _c("PageHeader", {
        attrs: { title: _vm.page.title, items: _vm.page.items }
      }),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "12" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { lg: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "系统",
                                "label-cols-sm": "3",
                                "label-align-sm": "right",
                                "label-for": "menu-system"
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "menu-system",
                                  options: _vm.types.menuSystemList,
                                  "value-field": "value",
                                  "text-field": "text"
                                },
                                on: { change: _vm.onChangeMenuSystem },
                                model: {
                                  value: _vm.search_condition.menuType,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "menuType",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.menuType"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "父级菜单",
                                "label-cols-sm": "3",
                                "label-align-sm": "right",
                                "label-for": "menu-parent"
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "menu-parent",
                                  options: _vm.types.menuParentList,
                                  "value-field": "id",
                                  "text-field": "name"
                                },
                                model: {
                                  value: _vm.search_condition.pid,
                                  callback: function($$v) {
                                    _vm.$set(_vm.search_condition, "pid", $$v)
                                  },
                                  expression: "search_condition.pid"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "名称",
                                "label-cols-sm": "3",
                                "label-align-sm": "right",
                                "label-for": "menu-name"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "menu-name", trim: "" },
                                model: {
                                  value: _vm.search_condition.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.search_condition, "name", $$v)
                                  },
                                  expression: "search_condition.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "2" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.search()
                                }
                              }
                            },
                            [_vm._v("查询")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-card",
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "has",
                          rawName: "v-has",
                          value: "menu::Create",
                          expression: "'menu::Create'"
                        }
                      ],
                      attrs: { variant: "primary" },
                      on: { click: _vm.gotoAdd }
                    },
                    [_vm._v("添加")]
                  ),
                  _c(
                    "div",
                    { staticClass: "table-responsive mb-0" },
                    [
                      _c("b-table", {
                        ref: "table",
                        attrs: {
                          "show-empty": "",
                          "empty-text": "no records",
                          id: "table",
                          "head-variant": "light",
                          busy: _vm.isBusy,
                          striped: true,
                          items: _vm.provider,
                          fields: _vm.fields,
                          "per-page": _vm.search_condition.pageSize,
                          "current-page": _vm.search_condition.pageNum,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          filter: _vm.filter,
                          "filter-includedfields": _vm.filterOn
                        },
                        on: {
                          "update:sortBy": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function($event) {
                            _vm.sortDesc = $event
                          },
                          filtered: _vm.onFiltered
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "table-busy",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-center text-danger my-2"
                                  },
                                  [
                                    _c("b-spinner", {
                                      staticClass: "align-middle"
                                    }),
                                    _c("strong", [_vm._v("Loading...")])
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "cell(index)",
                            fn: function(data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      data.index +
                                        (_vm.search_condition.pageNum - 1) *
                                          _vm.search_condition.pageSize +
                                        1
                                    ) +
                                    " "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(actions)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-button-group",
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "has",
                                            rawName: "v-has",
                                            value: "menu::Modify",
                                            expression: "'menu::Modify'"
                                          }
                                        ],
                                        staticClass: "mr-1",
                                        attrs: { size: "sm", variant: "info" },
                                        on: {
                                          click: function($event) {
                                            return _vm.edit(
                                              row.item,
                                              row.index,
                                              $event.target
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(" 修改 ")]
                                    ),
                                    row.item.type == 1
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "has",
                                                rawName: "v-has",
                                                value: "menu::Modify",
                                                expression: "'menu::Modify'"
                                              }
                                            ],
                                            staticClass: "mr-1",
                                            attrs: {
                                              size: "sm",
                                              variant: "warning"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.editButton(
                                                  row.item,
                                                  row.index,
                                                  $event.target
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(" 按钮组 ")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm.has_data
                    ? _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dataTables_paginate paging_simple_numbers float-right"
                              },
                              [
                                _vm.rows != 0
                                  ? _c(
                                      "ul",
                                      { staticClass: "pagination mb-0" },
                                      [
                                        _c("b-pagination", {
                                          attrs: {
                                            "per-page": 10,
                                            "total-rows": _vm.rows,
                                            "aria-controls": "table"
                                          },
                                          model: {
                                            value: _vm.search_condition.pageNum,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.search_condition,
                                                "pageNum",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "search_condition.pageNum"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal",
            size: "lg",
            centered: "",
            title: _vm.menuInfo.id ? "添加" : "修改",
            "ok-title": "提交",
            "cancel-title": "取消",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          },
          on: { close: _vm.onCloseDetailModal },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [_c("div", { staticClass: "w-100" })]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.showMenuDetailModal,
            callback: function($$v) {
              _vm.showMenuDetailModal = $$v
            },
            expression: "showMenuDetailModal"
          }
        },
        [
          _c(
            "b-card",
            [
              _c(
                "b-form",
                {
                  attrs: { id: "menuInfoForm" },
                  on: {
                    submit: _vm.onConfirmMenuInfo,
                    reset: _vm.onCancelDetailModal
                  }
                },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "平台：",
                        "label-cols-lg": "2",
                        "label-align-lg": "right",
                        "label-for": "modal-menu-system",
                        "label-class": "requiredRow"
                      }
                    },
                    [
                      _c("b-form-select", {
                        staticClass: "col-lg-10",
                        attrs: {
                          id: "modal-menu-system",
                          options: _vm.types.menuSystemList,
                          required: "",
                          oninvalid: "setCustomValidity('Please select');",
                          oninput: "setCustomValidity('')",
                          disabled: _vm.menuInfo.id != 0 ? true : false
                        },
                        on: { change: _vm.onChangeModalMenuSystem },
                        model: {
                          value: _vm.menuInfo.menuType,
                          callback: function($$v) {
                            _vm.$set(_vm.menuInfo, "menuType", $$v)
                          },
                          expression: "menuInfo.menuType"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "菜单级别：",
                        "label-cols-lg": "2",
                        "label-align-lg": "right",
                        "label-for": "modal-menu-level",
                        "label-class": "requiredRow"
                      }
                    },
                    [
                      _c("b-form-select", {
                        staticClass: "col-lg-10",
                        attrs: {
                          id: "modal-menu-level",
                          options: _vm.types.menuLevelList,
                          required: "",
                          oninvalid: "setCustomValidity('Please select');",
                          oninput: "setCustomValidity('')",
                          disabled: _vm.menuInfo.id != 0 ? true : false
                        },
                        model: {
                          value: _vm.menuInfo.type,
                          callback: function($$v) {
                            _vm.$set(_vm.menuInfo, "type", $$v)
                          },
                          expression: "menuInfo.type"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.menuInfo.type == 1
                    ? _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "父级菜单：",
                            "label-cols-lg": "2",
                            "label-align-lg": "right",
                            "label-for": "modal-menu-parent",
                            "label-class": "requiredRow"
                          }
                        },
                        [
                          _c("b-form-select", {
                            staticClass: "col-lg-10",
                            attrs: {
                              id: "modal-menu-parent",
                              options: _vm.types.modalMenuParentList,
                              required: "",
                              oninvalid: "setCustomValidity('Please select');",
                              oninput: "setCustomValidity('')",
                              "text-field": "name",
                              "value-field": "id"
                            },
                            model: {
                              value: _vm.menuInfo.pid,
                              callback: function($$v) {
                                _vm.$set(_vm.menuInfo, "pid", $$v)
                              },
                              expression: "menuInfo.pid"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "名称：",
                        "label-cols-lg": "2",
                        "label-align-lg": "right",
                        "label-for": "modal-menu-name",
                        "label-class": "requiredRow"
                      }
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "col-lg-10",
                        attrs: {
                          id: "modal-menu-name",
                          required: "",
                          oninvalid: "setCustomValidity('Please enter');",
                          oninput:
                            "setCustomValidity('');if(value.length > 50)value = value.slice(0, 50)",
                          placeholder: "Please enter"
                        },
                        model: {
                          value: _vm.menuInfo.name,
                          callback: function($$v) {
                            _vm.$set(_vm.menuInfo, "name", $$v)
                          },
                          expression: "menuInfo.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.menuInfo.type == 0
                    ? _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "路径：",
                            "label-cols-lg": "2",
                            "label-align-lg": "right",
                            "label-for": "modal-menu-href"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "col-lg-10",
                            attrs: {
                              id: "modal-menu-href",
                              oninvalid: "setCustomValidity('Please enter');",
                              oninput:
                                "setCustomValidity('');if(value.length > 50)value = value.slice(0, 50)",
                              placeholder: "Please enter"
                            },
                            model: {
                              value: _vm.menuInfo.href,
                              callback: function($$v) {
                                _vm.$set(_vm.menuInfo, "href", $$v)
                              },
                              expression: "menuInfo.href"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.menuInfo.type == 1
                    ? _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "路径：",
                            "label-cols-lg": "2",
                            "label-align-lg": "right",
                            "label-for": "modal-menu-href",
                            "label-class": "requiredRow"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "col-lg-10",
                            attrs: {
                              id: "modal-menu-href",
                              required: "",
                              oninvalid: "setCustomValidity('Please enter');",
                              oninput:
                                "setCustomValidity('');if(value.length > 50)value = value.slice(0, 50)",
                              placeholder: "Please enter"
                            },
                            model: {
                              value: _vm.menuInfo.href,
                              callback: function($$v) {
                                _vm.$set(_vm.menuInfo, "href", $$v)
                              },
                              expression: "menuInfo.href"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "图标：",
                        "label-cols-lg": "2",
                        "label-align-lg": "right",
                        "label-for": "modal-menu-icon"
                      }
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "col-lg-10",
                        attrs: {
                          id: "modal-menu-icon",
                          oninvalid: "setCustomValidity('Please enter');",
                          oninput:
                            "setCustomValidity('');if(value.length > 50)value = value.slice(0, 50)",
                          placeholder: "Please enter"
                        },
                        model: {
                          value: _vm.menuInfo.icon,
                          callback: function($$v) {
                            _vm.$set(_vm.menuInfo, "icon", $$v)
                          },
                          expression: "menuInfo.icon"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "排序：",
                        "label-cols-lg": "2",
                        "label-align-lg": "right",
                        "label-for": "modal-menu-sort"
                      }
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "col-lg-10",
                        attrs: {
                          id: "modal-menu-sort",
                          type: "number",
                          oninvalid: "setCustomValidity('Please enter');",
                          oninput:
                            "setCustomValidity('');if(value.length > 50)value = value.slice(0, 50)",
                          placeholder: "Please enter"
                        },
                        model: {
                          value: _vm.menuInfo.sort,
                          callback: function($$v) {
                            _vm.$set(_vm.menuInfo, "sort", $$v)
                          },
                          expression: "menuInfo.sort"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "快捷菜单名称：",
                        "label-cols-lg": "2",
                        "label-align-lg": "right",
                        "label-for": "modal-menu-quick-name"
                      }
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "col-lg-10",
                        attrs: {
                          id: "modal-menu-quick-name",
                          oninvalid: "setCustomValidity('Please enter');",
                          oninput:
                            "setCustomValidity('');if(value.length > 50)value = value.slice(0, 50)",
                          placeholder: "Please enter"
                        },
                        model: {
                          value: _vm.menuInfo.quickName,
                          callback: function($$v) {
                            _vm.$set(_vm.menuInfo, "quickName", $$v)
                          },
                          expression: "menuInfo.quickName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "快捷菜单图标：",
                        "label-cols-lg": "2",
                        "label-align-lg": "right",
                        "label-for": "modal-menu-quick-icon"
                      }
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "col-lg-10",
                        attrs: {
                          id: "modal-menu-quick-icon",
                          oninvalid: "setCustomValidity('Please enter');",
                          oninput:
                            "setCustomValidity('');if(value.length > 50)value = value.slice(0, 50)",
                          placeholder: "Please enter"
                        },
                        model: {
                          value: _vm.menuInfo.quickIcon,
                          callback: function($$v) {
                            _vm.$set(_vm.menuInfo, "quickIcon", $$v)
                          },
                          expression: "menuInfo.quickIcon"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.menuInfo.menuType == 2 || _vm.menuInfo.menuType == 3
                    ? _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "菜单别名：",
                            "label-cols-lg": "2",
                            "label-align-lg": "right",
                            "label-for": "modal-menu-alias"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "col-lg-10",
                            attrs: {
                              id: "modal-menu-alias",
                              oninvalid: "setCustomValidity('Please enter');",
                              oninput:
                                "setCustomValidity('');if(value.length > 50)value = value.slice(0, 50)",
                              placeholder: "Please enter"
                            },
                            model: {
                              value: _vm.menuInfo.menuAlias,
                              callback: function($$v) {
                                _vm.$set(_vm.menuInfo, "menuAlias", $$v)
                              },
                              expression: "menuInfo.menuAlias"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-form-group",
                    { attrs: { "label-cols-lg": "5" } },
                    [
                      _c(
                        "b-button",
                        { attrs: { type: "submit", variant: "primary" } },
                        [_vm._v("提交")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "m-l-5 ml-1",
                          attrs: { type: "reset", variant: "secondary" }
                        },
                        [_vm._v("取消")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-button",
            size: "lg",
            centered: "",
            title: "按钮组",
            "ok-title": "提交",
            "cancel-title": "取消",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          },
          on: { close: _vm.onCloseButtonModal },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [_c("div", { staticClass: "w-100" })]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.showMenuButtonModal,
            callback: function($$v) {
              _vm.showMenuButtonModal = $$v
            },
            expression: "showMenuButtonModal"
          }
        },
        [
          _c(
            "b-card",
            [
              _c(
                "b-form",
                {
                  attrs: { id: "menuButtonForm" },
                  on: {
                    submit: _vm.onConfirmMenuButton,
                    reset: _vm.onCloseButtonModal
                  }
                },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "PID：",
                        "label-cols-lg": "2",
                        "label-align-lg": "right",
                        "label-for": "modal-button-pid"
                      }
                    },
                    [
                      _c(
                        "b-form-text",
                        {
                          staticClass: "col-lg-10 pt-1",
                          attrs: { id: "modal-button-pid" }
                        },
                        [_c("h6", [_vm._v(_vm._s(_vm.menuInfo.id))])]
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "父级菜单：",
                        "label-cols-lg": "2",
                        "label-align-lg": "right",
                        "label-for": "modal-button-parent"
                      }
                    },
                    [
                      _c(
                        "b-form-text",
                        {
                          staticClass: "col-lg-10 pt-1",
                          attrs: { id: "modal-button-parent" }
                        },
                        [_c("h6", [_vm._v(_vm._s(_vm.menuInfo.name))])]
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "权限别名：",
                        "label-cols-lg": "2",
                        "label-align-lg": "right",
                        "label-for": "modal-button-permission",
                        "label-class": "requiredRow"
                      }
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "col-lg-10",
                        attrs: {
                          id: "modal-button-permission",
                          required: "",
                          oninvalid: "setCustomValidity('Please enter');",
                          oninput:
                            "setCustomValidity('');if(value.length > 50)value = value.slice(0, 50)",
                          placeholder: "Please enter"
                        },
                        model: {
                          value: _vm.menuInfo.permission,
                          callback: function($$v) {
                            _vm.$set(_vm.menuInfo, "permission", $$v)
                          },
                          expression: "menuInfo.permission"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "按钮组：",
                        "label-cols-lg": "2",
                        "label-align-lg": "right",
                        "label-for": "modal-button-group"
                      }
                    },
                    [
                      _c("b-form-checkbox-group", {
                        staticClass: "pt-2",
                        attrs: {
                          form: "menuButtonForm",
                          id: "modal-button-group",
                          options: _vm.types.buttonGroup,
                          switches: ""
                        },
                        model: {
                          value: _vm.selectButtonList,
                          callback: function($$v) {
                            _vm.selectButtonList = $$v
                          },
                          expression: "selectButtonList"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    { attrs: { "label-cols-lg": "5" } },
                    [
                      _c(
                        "b-button",
                        { attrs: { type: "submit", variant: "primary" } },
                        [_vm._v("提交")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "m-l-5 ml-1",
                          attrs: { type: "reset", variant: "secondary" }
                        },
                        [_vm._v("取消")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }